import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, Download, FileText, Video } from "lucide-react";

const MegazoneDownloadsSection = () => {
  return (
    <section className="py-16 px-4 md:px-8 bg-gradient-to-b from-background to-background/90">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row gap-8 items-center">
          <div className="flex-1">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Megazone Downloads
            </h2>
            <p className="text-lg text-muted-foreground mb-6">
              Aprenda a criar conteúdo incrível com nossos tutoriais sobre TikTok, YouTube, criação de sites, blogs e muito mais.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              <div className="flex items-start gap-2">
                <Video className="h-5 w-5 text-primary mt-1" />
                <div>
                  <h3 className="font-medium">Tutoriais de Criação</h3>
                  <p className="text-sm text-muted-foreground">
                    Aprenda a criar vídeos e editar conteúdo para suas redes sociais
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <Download className="h-5 w-5 text-primary mt-1" />
                <div>
                  <h3 className="font-medium">Downloads Úteis</h3>
                  <p className="text-sm text-muted-foreground">
                    Ferramentas e recursos para download e edição de conteúdo
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <FileText className="h-5 w-5 text-primary mt-1" />
                <div>
                  <h3 className="font-medium">Guias de Sites</h3>
                  <p className="text-sm text-muted-foreground">
                    Conheça os melhores sites da internet para suas necessidades
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <Video className="h-5 w-5 text-primary mt-1" />
                <div>
                  <h3 className="font-medium">Séries Japonesas</h3>
                  <p className="text-sm text-muted-foreground">
                    Coleção de séries tokusatsu, Ultraman e outras produções japonesas
                  </p>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-3">
              <Button asChild>
                <Link to="/megazone-downloads">
                  Explorar Tutoriais
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
              <Button asChild variant="outline">
                <a 
                  href="https://megazonedownloads.comunidades.net/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Visitar Site Original
                </a>
              </Button>
            </div>
          </div>
          <div className="flex-1">
            <div className="grid grid-cols-2 gap-4">
              <img 
                src="https://oaidalleapiprodscus.blob.core.windows.net/private/org-ct6DYAeKceEiQOX0yD2moI7R/user-f0xXHxP7OLYpXKo5T8F4XHV9/img-QUDdnkB5xzQQhkCyMO9YnYsz.png?st=2023-11-25T02%3A27%3A50Z&se=2023-11-25T04%3A27%3A50Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-11-24T22%3A27%3A14Z&ske=2023-11-25T22%3A27%3A14Z&sks=b&skv=2021-08-06&sig=FwGHKCCHKYzAZ/Ik/Aq4UxA7hJcUcG0Wl2n5TxiRMYE%3D"
                alt="Como ganhar seguidores no TikTok" 
                className="rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-300 object-cover w-full h-full"
              />
              <img 
                src="https://oaidalleapiprodscus.blob.core.windows.net/private/org-ct6DYAeKceEiQOX0yD2moI7R/user-f0xXHxP7OLYpXKo5T8F4XHV9/img-2mPYnkF4KwpLUQfqT6KKaZ3R.png?st=2023-11-25T02%3A28%3A26Z&se=2023-11-25T04%3A28%3A26Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-11-25T01%3A43%3A12Z&ske=2023-11-26T01%3A43%3A12Z&sks=b&skv=2021-08-06&sig=qyM%2BWZUB%2BX3ukZzbxPbBVrLCH9iiPmq5uY13xTxEh5c%3D"
                alt="Criando vídeos pelo ChatGPT" 
                className="rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-300 object-cover w-full h-full"
              />
              <img 
                src="https://oaidalleapiprodscus.blob.core.windows.net/private/org-ct6DYAeKceEiQOX0yD2moI7R/user-f0xXHxP7OLYpXKo5T8F4XHV9/img-5C9bkxCFB6BkqRTLtI9qiV4b.png?st=2023-11-25T02%3A28%3A54Z&se=2023-11-25T04%3A28%3A54Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-11-24T23%3A50%3A25Z&ske=2023-11-25T23%3A50%3A25Z&sks=b&skv=2021-08-06&sig=vdFo%2BkbtjFOTGGTZh26Rn6KLw5lS6fMcpbZxpM4Bq5g%3D"
                alt="Como criar um blog" 
                className="rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-300 object-cover w-full h-full"
              />
              <img 
                src="https://oaidalleapiprodscus.blob.core.windows.net/private/org-ct6DYAeKceEiQOX0yD2moI7R/user-f0xXHxP7OLYpXKo5T8F4XHV9/img-DUGbwBg0VZPBN3CIQGbMZeaU.png?st=2023-11-25T02%3A29%3A40Z&se=2023-11-25T04%3A29%3A40Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-11-24T22%3A27%3A33Z&ske=2023-11-25T22%3A27%3A33Z&sks=b&skv=2021-08-06&sig=uCCsYajEBSWuuO/k0rYhFbL/rVBZ0OGNadbZFM9clCg%3D"
                alt="Séries Japonesas" 
                className="rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-300 object-cover w-full h-full"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MegazoneDownloadsSection;